import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { ListItemLineInput } from '@trackback/widgets';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';
import { MatListItemLine } from '@angular/material/list';
import parsed from '@app/utils/parsed';

@Component({
  selector: 'div[tb-list-item-line]',
  imports: [DynamicWidgetDirective],
  template: `
    @for (child of input().children; track $index) {
      <ng-container [dynamicWidget]="child" [context]="context()" />
    }
  `,
  host: {
    '[class]': 'parsedStyleClasses()',
  },
  hostDirectives: [MatListItemLine],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class ListItemLineComponent extends WidgetInputBaseComponent<ListItemLineInput> {
  styleClasses = computed(() => this.input().styleClasses);
  parsedStyleClasses = parsed(this.styleClasses, this.context);
}
